/* Erevotech: WhatsApp & phone click tracking
   Catches clicks on:
   1. Any wa.me / api.whatsapp.com link (Inquire Now buttons, and any
      other WhatsApp links anywhere on the site)
   2. The floating WhatsApp chat widget (#chwhatsapp-btn, from the
      Carthike app) — a <button>, not a link, so it needs its own check
   3. Any tel: phone number link
   Pushes a GA4 event through the existing GTM dataLayer bridge
   (see theme.liquid). */
(function () {
  function pushEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  document.addEventListener('click', function (event) {
    // Floating WhatsApp widget button (Carthike app)
    var widgetBtn = event.target.closest('#chwhatsapp-btn, [id*="whatsapp-btn" i], [class*="whatsappbutton" i]');
    if (widgetBtn) {
      pushEvent({
        event: 'whatsapp_click',
        whatsapp_source: 'floating_widget',
        page_path: window.location.pathname
      });
      return;
    }

    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';

    // WhatsApp links (covers wa.me and api.whatsapp.com, any app or button)
    if (/(^https?:\/\/)?(wa\.me|api\.whatsapp\.com)/i.test(href)) {
      var source = link.getAttribute('data-hh-track') || 'whatsapp_general';
      pushEvent({
        event: 'whatsapp_click',
        whatsapp_source: source,
        link_url: href,
        page_path: window.location.pathname
      });
      return;
    }

    // Phone number links
    if (/^tel:/i.test(href)) {
      pushEvent({
        event: 'phone_click',
        link_url: href,
        page_path: window.location.pathname
      });
    }
  }, true);
})();
